import React from 'react';
import { observer,inject } from 'mobx-react';
import LoadingSpinner from '../LoadingSpinner';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Utils from '../../Utils';

@inject('roomStore')
@observer
export default class RoomList extends React.Component {
    componentDidMount(){
        this.props.roomStore.GetRooms();
    }
    dateFormater(cell,row){
        return Utils.Dates.ToString("dd/mm/yyyy",cell);
    }
   render(){
      if(!this.props.roomStore.LoadingRooms){
        return(<BootstrapTable data={this.props.roomStore.Rooms} striped={true} hover={true}>
        <TableHeaderColumn dataField="Name" isKey={true} dataSort={true} >Name</TableHeaderColumn>
        <TableHeaderColumn dataField="Color" >Background Color</TableHeaderColumn>
        <TableHeaderColumn dataField="Extension" >Extension</TableHeaderColumn>
        <TableHeaderColumn dataField="NameColor" >Text Color</TableHeaderColumn>
    </BootstrapTable>);
      }
      else{
        return(<LoadingSpinner/>);
      }
   }
}


// WEBPACK FOOTER //
// ./src/components/Rooms/RoomList.js